module.exports = __webpack_public_path__ + "media/images/about-us/twitter-823e96d6f5bfb38406c1a563507af063.svg";